import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import OverviewGraph from './OverviewGraph'

const CaptableManagementMap = ({
  title,
  valuationGraph,
  sharePriceGraph,
}: {
  title: string
  valuationGraph: any
  sharePriceGraph: any
}) => {
  const { formatMessage } = useIntl()
  const [price, setPrice] = useState(true) // eslint-disable-next-line
  const [seriesValidationData, setSeriesValidationData] = useState([{ name: 'Valuation', data: [] }])
  const [categoriesValidationData, setCategoriesValidationData] = useState([])
  const [seriesPriceData, setSeriesPriceData] = useState<any[]>([])
  const [categoriesPriceData, setCategoriesPriceData] = useState<any[]>([])

  useEffect(() => {
    if (valuationGraph && valuationGraph.length) {
      const transformedData = valuationGraph.map((item: any) => item.valuationOfTheWeek)
      setSeriesValidationData([{ name: 'Valuation', data: transformedData }])

      const extractedDates = valuationGraph.map((item: any) => item.weekStartDate)
      setCategoriesValidationData(extractedDates)
    }
  }, [valuationGraph])

  const handlePrice = function () {
    setPrice(() => !price)
    setValuation(() => !valuation)
  }
  const [valuation, setValuation] = useState(false)
  const handleValuation = function () {
    setValuation(() => !valuation)
    setPrice(() => !price)
  }

  useEffect(() => {
    if (sharePriceGraph && sharePriceGraph.length) {
      // Extract data from sharePriceGraph
      const extractedDates = sharePriceGraph.map((item: any) => item.firstClosingDate) // Dates
      const transformedData = sharePriceGraph.map((item: any) => item.pricePerShare) // Prices

      // Aggregate data by month and year
      const aggregatedData = extractedDates.reduce((acc: any, date: any, index: any) => {
        const monthYear = date.slice(0, 7) // Extract YYYY-MM format
        if (!acc[monthYear]) {
          acc[monthYear] = []
        }
        acc[monthYear].push(transformedData[index]) // Add price to the corresponding month
        return acc
      }, {})

      // Prepare categories and series data
      const categoriesPriceData = Object.keys(aggregatedData) // Unique months for X-axis
      const seriesPriceData = [
        {
          name: 'Price Per Share',
          data: categoriesPriceData.map(
            (month) => aggregatedData[month].join(', ') // Combine prices for each month
          ),
        },
      ]

      // Update state
      setSeriesPriceData(seriesPriceData)
      setCategoriesPriceData(categoriesPriceData)
    }
  }, [sharePriceGraph])
  console.log(seriesPriceData, 'seriesPriceData')
  console.log(categoriesPriceData, 'categoriesPriceData')
  console.log(seriesValidationData, 'seriesValidationData')
  console.log(categoriesValidationData, 'categoriesValidationData')
  return (
    <Card className='w-100 p-4 bg-white'>
      <div className='d-flex flex-column justify-content-between align-items-top'>
        <div className='d-flex justify-content-between align-items-center w-100 px-4'>
          <p className='text-muted m-0'>{formatMessage({ id: title })}</p>
          <div>
            <button
              className={`btn border py-2 fs-6 ${price ? 'btn-primary' : 'text-muted'}`}
              style={{
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px',
                borderTopRightRadius: '0px',
                borderBottomRightRadius: '0px',
              }}
              onClick={handlePrice}
            >
              {formatMessage({ id: 'By Price' })}
            </button>
            <button
              className={`btn border py-2 fs-6 ${valuation ? 'btn-primary' : 'text-muted'}`}
              style={{
                borderTopRightRadius: '4px',
                borderBottomRightRadius: '4px',
                borderTopLeftRadius: '0px',
                borderBottomLeftRadius: '0px',
              }}
              onClick={handleValuation}
            >
              {formatMessage({ id: 'By Valuation' })}
            </button>
          </div>
        </div>
      </div>
      {price && seriesPriceData && categoriesPriceData && (
        <OverviewGraph series={seriesPriceData} categories={categoriesPriceData} />
      )}
      {valuation && seriesValidationData && categoriesValidationData && (
        <OverviewGraph series={seriesValidationData} categories={categoriesValidationData} />
      )}
    </Card>
  )
}

export default CaptableManagementMap
